import { BASE_URL } from '@/constants';
import { cn } from '@/lib/utils';
import { FC, memo } from 'react';

interface LoadingProps {
  className?: string;
  tip?: string;
}

const Loading: FC<LoadingProps> = ({ className, tip }) => {
  return (
    <div className={cn('flex flex-col justify-center items-center gap', className)}>
      <img src={`${BASE_URL}/loading.svg`} />
      {tip && <span>{tip}</span>}
    </div>
  );
};
export default memo(Loading);
